// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"3b3e20f9","643":"1eb8a06f"}[chunkId] + ".chunk.js";
};